import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';

import { actions } from '../actions/conversation';
import { timelineActions } from '../actions/timeline';

interface TimelineState {
  timelineItems: any[];
  currentRequesterId: any | null;
  asyncStatus: AsyncStatus | null;
}

const initialState: TimelineState = {
  timelineItems: [],
  currentRequesterId: null,
  asyncStatus: null,
};

const { conversationGetSucceeded, conversationGetBeforeSucceeded } = actions;

const {
  timelineGetRequest,
  timelineGetSucceeded,
  timelineGetFailed,
  timelineUpdateConversation,
  timelineClear,
} = timelineActions;

const timeline = handleActions<TimelineState, any>(
  {
    [conversationGetBeforeSucceeded.toString()]: (state, action) => {
      const metaConversation = action.payload.metaConversation;

      if (
        state.currentRequesterId !== metaConversation.conversation.requested_by
      ) {
        return {
          ...state,
          currentRequesterId: metaConversation.conversation.requested_by,
          timelineItems: [],
        };
      }

      return state;
    },
    [conversationGetSucceeded.toString()]: (state, action) => {
      const data = action.payload.data;

      if (
        state.currentRequesterId !== data.history.main_conversation.requested_by
      ) {
        return {
          ...state,
          currentRequesterId: data.history.main_conversation.requested_by,
          timelineItems: [],
        };
      }

      return state;
    },
    [timelineClear.toString()]: (state) => {
      return {
        ...state,
        currentRequesterId: null,
        timelineItems: [],
      };
    },
    [timelineGetRequest.toString()]: (state) => {
      return { ...state, asyncStatus: 'loading' };
    },
    [timelineGetSucceeded.toString()]: (state, action) => {
      if (state.currentRequesterId !== action.payload.requesterId) {
        return state;
      }
      return {
        ...state,
        timelineItems: action.payload.data.conversations,
        asyncStatus: null,
      };
    },
    [timelineGetFailed.toString()]: (state) => {
      return { ...state, asyncStatus: 'failed' };
    },
    [timelineUpdateConversation.toString()]: (state, action) => {
      const { conversation } = action.payload;

      for (const i in state.timelineItems) {
        if (conversation.id === state.timelineItems[i].id) {
          return {
            ...state,
            timelineItems: [
              ...state.timelineItems.filter((o) => o.id !== conversation.id),
              conversation,
            ],
          };
        }
      }
      return state;
    },
  },
  initialState,
);

export default timeline;
